import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";
import { Card, CardContent } from "../components/ui/card";
import { useLanguage } from "../contexts/LanguageContext";

const Imprint = () => {
  const { t } = useLanguage();

  return (
    <div className="theme-brand bg-surface text-ink min-h-screen bg-surface-sunken">
      <SEOHead
        title="Impressum | BROVKO GmbH"
        description="Rechtliche Informationen und Kontaktdaten der BROVKO GmbH - Ihr Partner für KI-Transformation."
        keywords="Impressum, BROVKO GmbH, Kontakt, Rechtliche Informationen"
        canonicalUrl="/imprint"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-slate-900 to-teal-900">
        <div className="container mx-auto px-4">
          <div className=" text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Impressum
            </h1>
            <p className="text-xl md:text-2xl text-ink-muted max-w-[62ch]">
              Rechtliche Informationen und Kontaktdaten
            </p>
          </div>
        </div>
      </section>

      {/* Imprint Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <Card className="border-0 shadow-lg">
              <CardContent className="p-8 md:p-12">
                
                {/* Company Information */}
                <div className="mb-8">
                  <h2 className="text-[clamp(1.9rem,3.6vw,3rem)] font-extrabold tracking-[-0.032em] leading-[1.06] [text-wrap:balance] text-ink mb-6">
                    Angaben gemäß § 5 TMG
                  </h2>
                  
                  <div className="space-y-2 text-ink-muted">
                    <p className="font-semibold text-lg">Brovko GmbH</p>
                    <p>Wieselpfad 21</p>
                    <p>30657 Hannover</p>
                  </div>
                </div>

                {/* Registration Details */}
                <div className="mb-8">
                  <div className="space-y-2 text-ink-muted">
                    <p><span className="font-medium">Handelsregister:</span> HRB 222663</p>
                    <p><span className="font-medium">Registergericht:</span> Amtsgericht Hannover</p>
                  </div>
                </div>

                {/* Representative */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold text-ink mb-4">
                    Vertreten durch:
                  </h3>
                  <p className="text-ink-muted">Alexander Brovko</p>
                </div>

                {/* Contact Information */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold text-ink mb-4">
                    Kontakt
                  </h3>
                  <div className="space-y-2 text-ink-muted">
                    <p><span className="font-medium">Telefon:</span> +49 (0)511 35333682</p>
                    <p>
                      <span className="font-medium">E-Mail:</span>{" "}
                      <a href="mailto:email@brovko.de" className="text-brand-400 hover:text-brand-300">
                        email@brovko.de
                      </a>
                    </p>
                  </div>
                </div>

                {/* VAT ID */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold text-ink mb-4">
                    Umsatzsteuer-ID
                  </h3>
                  <p className="text-ink-muted mb-2">
                    Umsatzsteuer-Identifikationsnummer (USt-IdNr.) gemäß § 27 a Umsatzsteuergesetz:
                  </p>
                  <p className="font-medium text-ink">DE348406485</p>
                </div>

                {/* Consumer Dispute Resolution */}
                <div className="mb-8">
                  <h3 className="text-xl font-semibold text-ink mb-4">
                    Verbraucherstreitbeilegung/Universalschlichtungsstelle
                  </h3>
                  <p className="text-ink-muted">
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>

                {/* Source */}
                <div className="border-t border-hairline pt-6">
                  <p className="text-sm text-ink-faint">
                    Quelle:{" "}
                    <a 
                      href="https://www.e-recht24.de/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-brand-400 hover:text-brand-300"
                    >
                      e-recht24.de
                    </a>
                  </p>
                </div>

              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Imprint;